import { Tooltip } from '@material-ui/core';
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord';
import { primaryGreen, unknownStatus, offlineStatus } from '../../data/colors';
import { format, isSameDay } from 'date-fns';

const getStatusColor = (status: boolean | null | undefined) => {
  if (status === true) return primaryGreen;
  if (status === false) return offlineStatus;
  return unknownStatus;
};

const getStatusTitle = (status: boolean | null | undefined) => {
  if (status === true) return 'Online';
  if (status === false) return 'Offline';
  return 'Unknown';
};

interface StatusIndicatorProps {
  isOnline?: boolean | null;
  siteFetchTime?: Date;
  className?: string;
}

const StatusIndicator = ({ isOnline, siteFetchTime, className }: StatusIndicatorProps) => {
  const color = getStatusColor(isOnline);
  let title = getStatusTitle(isOnline);

  if (siteFetchTime) {
    const timeStr = format(siteFetchTime, 'h:mm a');
    const isToday = isSameDay(siteFetchTime, new Date());
    const dateStr = isToday ? '' : ` on ${format(siteFetchTime, 'MM/dd/yyyy')}`;
    const newTitle = `${title} as of ${timeStr}${dateStr}`;
    title = newTitle;
  }

  return (
    <Tooltip title={title}>
      <FiberManualRecordIcon className={className} style={{ fill: color }} />
    </Tooltip>
  );
};

export default StatusIndicator;
